import { useState } from 'react'

import clsx from 'clsx'

import CheckIcon from 'shared/icons/tick_green_icon.svg'

import styles from './styles.module.scss'

interface Props {
  isChecked?: boolean
  title?: string | React.ReactNode
  error?: boolean
  onClick?: (value?: boolean) => void
  isBigSize?: boolean
}

export const CheckBox = ({
  isChecked = false,
  title,
  onClick,
  error,
  isBigSize,
}: Props) => {
  const [check, setChecked] = useState<boolean>(isChecked)

  const onClickHandler = () => {
    onClick && onClick(!check)
    setChecked(!check)
  }

  return (
    <div className={styles.container}>
      <div
        className={clsx(
          styles.box,
          error && styles.error,
          isBigSize && styles.big,
        )}
        onClick={onClickHandler}
      >
        {check ? (
          <img
            src={CheckIcon}
            alt=""
          />
        ) : (
          <div className={styles.unActive} />
        )}
      </div>

      {title && (
        <p
          className={styles.text}
          onClick={onClickHandler}
        >
          {title}
        </p>
      )}
    </div>
  )
}
